import { useMemo } from 'react';
import { Typography } from 'antd';
import { SmartDataTableProps } from '@src/components/SmartDataTable/types';
import { useOrganizationStatusRender } from './useOrganizationStatusRender';
import { useUserTimestampRender } from '@src/hooks';
import { ORGANIZATION_STATUS_FILTER_OPTIONS } from '../constants';

const { Text } = Typography;

export const useOrganizationsColumns = (): SmartDataTableProps['columns'] => {
  const getStatusConfig = useOrganizationStatusRender();
  const userTimestampRender = useUserTimestampRender({
    size: 'small',
  });

  return useMemo(
    () => [
      {
        key: 'id',
        title: 'ID',
        dataIndex: 'id',
        sorter: true,
        minWidth: 120,
        ellipsis: true,
        render: (value: any) => (
          <Text
            style={{
              fontSize: '12px',
              color: '#8c8c8c',
              backgroundColor: '#f5f5f5',
              padding: '2px 6px',
              borderRadius: '4px',
              fontFamily: 'monospace',
            }}
          >
            {value}
          </Text>
        ),
      },
      {
        key: 'name',
        title: 'Organization Name',
        dataIndex: 'name',
        sorter: true,
        minWidth: 200,
        ellipsis: true,
        render: (name: any) => (
          <Text style={{ fontWeight: 500, color: '#262626' }}>
            {name || 'N/A'}
          </Text>
        ),
      },
      {
        key: 'contact_email',
        title: 'Contact Email',
        dataIndex: 'contact_email',
        sorter: true,
        minWidth: 200,
        ellipsis: true,
        render: (email: any) => (
          <Text style={{ color: '#1890ff' }}>{email || 'N/A'}</Text>
        ),
      },
      {
        key: 'contact_mobile_no',
        title: 'Contact Mobile',
        dataIndex: 'contact_mobile_no',
        sorter: true,
        minWidth: 150,
        ellipsis: true,
        render: (mobile: any) => (
          <Text style={{ color: '#52c41a' }}>{mobile || 'N/A'}</Text>
        ),
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        sorter: true,
        minWidth: 120,
        filterable: true,
        filterType: 'select',
        filterOptions: ORGANIZATION_STATUS_FILTER_OPTIONS,
        render: (status: any) => getStatusConfig(status),
      },
      {
        key: 'user_timestamp',
        title: 'Created/Updated',
        dataIndex: 'created_at',
        sorter: true,
        minWidth: 180,
        render: (value: any, record: any) => userTimestampRender(record),
      },
    ],
    [getStatusConfig, userTimestampRender]
  );
};
